import usePersonalizedThemeByCompany from "src/hooks/usePersonalizedThemeByCompany"

type Props = {
 trendingUp: boolean
}

export default function TrendingIcon({  trendingUp}: Props) {
  const {styledTheme} = usePersonalizedThemeByCompany()
 
  if (trendingUp) return (
    <svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5.5L4.42857 2.16667L7.85714 5.5L13 0.5M13 0.5V3.83333M13 0.5H9.57143" stroke={styledTheme.icons.trendingIcon.upTextColor} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>)

  return (
    <svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0.5L4.42857 3.83333L7.85714 0.5L13 5.5M13 5.5V2.16667M13 5.5H9.57143" stroke={styledTheme.icons.trendingIcon.downTextColor} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>)
}
